module.exports = __webpack_public_path__ + "static/img/dCT4.1f066b11.png";